import React from 'react';
import PropTypes from 'prop-types';

import Column from '@Theme/hijunior/components/Column/Column';
import Container from '@Theme/hijunior/components/Container/Container';
import Picture from '@Theme/hijunior/components/Picture/Picture';
import Row from '@Theme/hijunior/components/Row/Row';
import Text from '@Theme/hijunior/components/Text/Text';

import * as styles from './Headline.module.scss';

const propTypes = {
  /**
   * Heading content
   * */
  heading: PropTypes.string,

  /**
   * Module description
   * */
  description: PropTypes.string,

  /**
   * Additional classname
   * */
  classname: PropTypes.string,

  /**
   * Photo source for different sizes of viewport
   */
  photo: PropTypes.shape({
    xs: PropTypes.object.isRequired,
    lg: PropTypes.object.isRequired,
    alt: PropTypes.string
  })
};

const Headline = ({
  description,
  heading,
  photo,
  classname
}) => {
  if (!heading && !description && !photo?.xs) {
    return false;
  }

  return (
    <section
      className={`${styles.root} ${classname || ''}`}>
      <Container>
        <Row classname={styles.rootRow}>
          {(heading || description) && <Column xs={4} md={6} lg={6}>
            {heading && <Text as='h1' contents={heading} classname={styles.rootHeading}/>}
            {description && <Text contents={description} classname={styles.rootDescription}/>}
          </Column>}
          {photo?.xs && <Column xs={4} md={6} lg={6}>
            <Picture {...photo} pictureClassname={styles.rootPicture} imgClassname={styles.rootImage}/>
          </Column>}
        </Row>
      </Container>
    </section>
  );
};

Headline.propTypes = propTypes;

export default Headline;
